function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.61,198.93c-4.62.54-16.59,8.7-17.41,9.52s-4.08,2.72-5.44,3.81c0,0-28,17.41-30.47,19s-7.34,4.89-7.07,6-14.42,25-14.42,25-4.35,5.71-.27,10.88,7.89,1.63,9.79.55,16.87-15.24,16.87-15.24L340,291.45s19.12-12.82,39.52-12l-13.6-53.32s18.77-14.15,19.31-19S379.24,198.38,374.61,198.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.25,271.27c-4.36-23-18.45-39.8-36.79-53.31-13.09-9.65-23.72-22.27-32.84-35.71-12.74-18.79-23.31-42.3-43.91-53.92-29.3-16.52-57.47,5.95-81.22,21.8-12.46,8.32-25.75,17-40.83,19.4-21.5,3.44-43.33-6-64.65-.32A33.87,33.87,0,0,0,97,172s-27,9-35,55S61,342,99,382s68,45,88,46c.55,0,1.09,0,1.63,0,13.27,2,29,1,47-4,57.88-16.08,54.66-53.06,106.11-61.1S418.09,317.89,409.25,271.27Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.25,271.27c-4.36-23-18.45-39.8-36.79-53.31-13.09-9.65-23.72-22.27-32.84-35.71-12.74-18.79-23.31-42.3-43.91-53.92-29.3-16.52-57.47,5.95-81.22,21.8-12.46,8.32-25.75,17-40.83,19.4-21.5,3.44-43.33-6-64.65-.32A33.87,33.87,0,0,0,97,172s-27,9-35,55S61,342,99,382s68,45,88,46c.55,0,1.09,0,1.63,0,13.27,2,29,1,47-4,57.88-16.08,54.66-53.06,106.11-61.1S418.09,317.89,409.25,271.27Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.12,91.64s4.58-3.62,5.76-5.94c1-2,1.72-4.78.69-6.88A3.93,3.93,0,0,0,223,77c-2.83,1.76-3.13,7.74-2.41,10.62C220.65,87.9,222.07,91.68,222.12,91.64Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.75,121.79c.19.18,3.46,2.55,3.47,2.49s1.83-5.55,1.53-8.13c-.26-2.2-1.2-4.94-3.22-6.12a3.92,3.92,0,0,0-5.63,1.58C174.51,114.63,177.56,119.79,179.75,121.79Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.78,97.12S259,114.44,259.09,135.71s17,38.45,17,38.45,16.78-17.32,16.69-38.59S275.78,97.12,275.78,97.12Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.86,148.46a7.39,7.39,0,0,0,.6-.77c1.22-1.85,2.26-4.54,1.48-6.75a3.93,3.93,0,0,0-5.33-2.42c-2.28,1.08-3.39,4.73-3.63,7.72-.91-.21-1.73-.37-2.44-.49-.3-.67-.6-1.36-.91-2s-.56-1.42-.85-2.14c-.4-1.06-.76-2.18-1.13-3.29,1.33-.6,5.2-2.4,6.64-4s2.92-4.15,2.48-6.45a3.93,3.93,0,0,0-4.9-3.2c-3.19,1-5.06,6.64-5.13,9.61,0,.1,0,.73.12,1.47-.32-1.1-.65-2.19-.93-3.31-.82-3.19-1.56-6.46-2.31-9.73-.15-.69-.32-1.36-.48-2,1.12-.49,5.32-2.41,6.83-4.08s2.93-4.15,2.49-6.45a3.94,3.94,0,0,0-4.91-3.2c-3.18,1-5.05,6.64-5.12,9.61,0,.1.06.85.14,1.69-.44-1.77-.89-3.53-1.39-5.27a69,69,0,0,0-3.14-8.74c.4-.17,5.37-2.32,7.05-4.18,1.49-1.64,2.92-4.15,2.48-6.45a3.93,3.93,0,0,0-4.9-3.2c-3.18,1-5.06,6.64-5.12,9.61,0,.21.24,2.92.36,3.89l0-.1a50.48,50.48,0,0,0-4.57-7.89,69.55,69.55,0,0,0-5-6.41c-1.65-1.9-3.28-3.55-4.73-5-.8-.77-1.54-1.47-2.23-2.11h.07c.06,0-1.56-3.71-1.69-3.93-1.48-2.57-5.87-6.65-9.12-6a3.94,3.94,0,0,0-2.75,5.17c.73,2.23,3.19,3.73,5.29,4.45s6.83.39,8,.28c.71.68,1.46,1.42,2.27,2.24,1.42,1.47,3,3.15,4.62,5.08.42.51.86,1.09,1.3,1.63-.93-.77-2.21-1.8-2.35-1.89-2.5-1.59-8.28-3.19-10.83-1.07a3.92,3.92,0,0,0-.07,5.85c1.67,1.65,4.56,1.84,6.75,1.52s6.37-2.89,7.26-3.46c.95,1.22,1.9,2.5,2.81,3.89a51.12,51.12,0,0,1,4.33,7.89c.07.16.12.33.19.49-.39-.46-2.73-2.81-2.91-3-2.31-1.86-7.87-4.09-10.65-2.26a3.93,3.93,0,0,0-.71,5.81c1.49,1.82,4.33,2.33,6.54,2.25,2.56-.09,7.58-2.63,7.77-2.72a68.08,68.08,0,0,1,2.84,8.52c.57,2.14,1.07,4.34,1.54,6.54-.52-.58-2.69-2.77-2.87-2.91-2.31-1.86-7.87-4.09-10.65-2.26a3.93,3.93,0,0,0-.71,5.81c1.49,1.82,4.33,2.33,6.54,2.25,2.5-.09,7.32-2.5,7.73-2.7.22,1,.43,2,.64,3,.68,3.28,1.35,6.58,2.1,9.81.26,1.12.56,2.21.86,3.31-.82-.85-2.33-2.37-2.47-2.49-2.31-1.85-7.88-4.08-10.65-2.26a3.93,3.93,0,0,0-.71,5.81c1.48,1.82,4.33,2.34,6.54,2.25s6.33-2,7.48-2.58c.5,1.82,1,3.62,1.66,5.36.28.75.52,1.53.83,2.23l.47,1.11-.64-.06s0,1,.05,2.73c-2.44-1.74-6-3.24-8.25-2.18a3.93,3.93,0,0,0-1.58,5.63,5.11,5.11,0,0,0,.51.71,15.35,15.35,0,0,0,3.16,7c.12.15,1.78,1.68,2.65,2.44-.84-.45-1.67-.9-2.53-1.38-1.25-.7-2.54-1.47-3.8-2.21l-1.94-1.23c-.66-.41-1.25-.87-1.89-1.31-.92-.67-1.84-1.4-2.75-2.13.78-1.22,3-4.86,3.33-7s.14-5.08-1.49-6.76a3.94,3.94,0,0,0-5.86,0c-2.13,2.55-.55,8.33,1,10.84,0,.08.44.58.91,1.16-.87-.74-1.75-1.47-2.61-2.25-2.44-2.2-4.86-4.53-7.29-6.84l-1.53-1.44c.66-1,3.11-5,3.45-7.17s.15-5.08-1.49-6.76a3.94,3.94,0,0,0-5.85,0c-2.13,2.55-.56,8.33,1,10.84.06.09.53.68,1.05,1.34-1.33-1.24-2.69-2.46-4.06-3.63a69.83,69.83,0,0,0-7.44-5.56c.24-.36,3.2-4.9,3.57-7.37.34-2.2.15-5.08-1.48-6.76a4,4,0,0,0-5.86,0c-2.13,2.55-.55,8.33,1,10.84.11.18,1.81,2.3,2.45,3l-.09-.06a51.62,51.62,0,0,0-8.16-4.06,69.84,69.84,0,0,0-7.74-2.56c-2.43-.68-4.7-1.15-6.71-1.55-1.08-.21-2.08-.38-3-.53l.06,0s-3.34-2.24-3.57-2.35c-2.66-1.32-8.57-2.31-10.89.07a3.94,3.94,0,0,0,.55,5.83c1.84,1.46,4.72,1.35,6.87.8s5.91-3.46,6.83-4.18c1,.17,2,.37,3.13.61,2,.44,4.24,1,6.65,1.69.64.19,1.32.43,2,.64-1.2-.13-2.84-.28-3-.28-3,0-8.67,1.9-9.63,5.08a3.93,3.93,0,0,0,3.17,4.92c2.3.45,4.82-1,6.47-2.46s3.72-5.92,4.15-6.89c1.46.5,3,1,4.48,1.7a51.25,51.25,0,0,1,8,4.18c.14.1.28.22.43.31-.58-.16-3.83-.84-4.06-.86-3-.28-8.83.93-10.13,4a3.94,3.94,0,0,0,2.61,5.24c2.24.7,4.9-.45,6.7-1.73,2.08-1.49,4.87-6.38,5-6.56a69.42,69.42,0,0,1,7.06,5.54c1.67,1.47,3.29,3,4.9,4.61-.76-.2-3.78-.83-4-.85-3-.27-8.82.94-10.13,4a3.94,3.94,0,0,0,2.61,5.24c2.24.7,4.9-.44,6.7-1.73,2-1.45,4.73-6.13,5-6.52l2.2,2.15c2.38,2.37,4.75,4.75,7.16,7,.84.79,1.69,1.54,2.54,2.29-1.14-.26-3.24-.7-3.43-.71-2.95-.28-8.82.93-10.13,4a3.94,3.94,0,0,0,2.62,5.24c2.24.69,4.89-.45,6.69-1.73s4.17-5.18,4.82-6.28c1.42,1.24,2.86,2.44,4.34,3.55.65.47,1.28,1,1.92,1.4l1.91,1.27c1.33.83,2.57,1.6,3.83,2.34l1.86,1.07c-1.12-.44-2.91-1.1-3.08-1.14-2.88-.72-8.86-.42-10.62,2.41a3.94,3.94,0,0,0,1.79,5.57c2.11,1,4.91.3,6.88-.7,2.18-1.1,5.46-5.16,5.86-5.66,1.53.87,3,1.7,4.43,2.45,3.77,2,7,3.63,9.6,4.82,8.29,7.17,20,8,20,8s.62-14-7.61-23.16A28.65,28.65,0,0,0,251.86,148.46Zm-14.8,13.62c.26-.58,2.24-5,2.38-7.52.46-.08.93-.18,1.38-.28a32.3,32.3,0,0,0,5.14,12.3c-1.51-.72-3.14-1.51-4.87-2.39C239.8,163.53,238.45,162.82,237.06,162.08Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,145.78s-14,.43-22.53,9.32S282,178,282,178s14-.43,22.53-9.32S313,145.78,313,145.78Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.12,91.64s4.58-3.62,5.76-5.94c1-2,1.72-4.78.69-6.88A3.93,3.93,0,0,0,223,77c-2.83,1.76-3.13,7.74-2.41,10.62C220.65,87.9,222.07,91.68,222.12,91.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.75,121.79c.19.18,3.46,2.55,3.47,2.49s1.83-5.55,1.53-8.13c-.26-2.2-1.2-4.94-3.22-6.12a3.92,3.92,0,0,0-5.63,1.58C174.51,114.63,177.56,119.79,179.75,121.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.78,97.12S259,114.44,259.09,135.71s17,38.45,17,38.45,16.78-17.32,16.69-38.59S275.78,97.12,275.78,97.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.86,148.46a7.39,7.39,0,0,0,.6-.77c1.22-1.85,2.26-4.54,1.48-6.75a3.93,3.93,0,0,0-5.33-2.42c-2.28,1.08-3.39,4.73-3.63,7.72-.91-.21-1.73-.37-2.44-.49-.3-.67-.6-1.36-.91-2s-.56-1.42-.85-2.14c-.4-1.06-.76-2.18-1.13-3.29,1.33-.6,5.2-2.4,6.64-4s2.92-4.15,2.48-6.45a3.93,3.93,0,0,0-4.9-3.2c-3.19,1-5.06,6.64-5.13,9.61,0,.1,0,.73.12,1.47-.32-1.1-.65-2.19-.93-3.31-.82-3.19-1.56-6.46-2.31-9.73-.15-.69-.32-1.36-.48-2,1.12-.49,5.32-2.41,6.83-4.08s2.93-4.15,2.49-6.45a3.94,3.94,0,0,0-4.91-3.2c-3.18,1-5.05,6.64-5.12,9.61,0,.1.06.85.14,1.69-.44-1.77-.89-3.53-1.39-5.27a69,69,0,0,0-3.14-8.74c.4-.17,5.37-2.32,7.05-4.18,1.49-1.64,2.92-4.15,2.48-6.45a3.93,3.93,0,0,0-4.9-3.2c-3.18,1-5.06,6.64-5.12,9.61,0,.21.24,2.92.36,3.89l0-.1a50.48,50.48,0,0,0-4.57-7.89,69.55,69.55,0,0,0-5-6.41c-1.65-1.9-3.28-3.55-4.73-5-.8-.77-1.54-1.47-2.23-2.11h.07c.06,0-1.56-3.71-1.69-3.93-1.48-2.57-5.87-6.65-9.12-6a3.94,3.94,0,0,0-2.75,5.17c.73,2.23,3.19,3.73,5.29,4.45s6.83.39,8,.28c.71.68,1.46,1.42,2.27,2.24,1.42,1.47,3,3.15,4.62,5.08.42.51.86,1.09,1.3,1.63-.93-.77-2.21-1.8-2.35-1.89-2.5-1.59-8.28-3.19-10.83-1.07a3.92,3.92,0,0,0-.07,5.85c1.67,1.65,4.56,1.84,6.75,1.52s6.37-2.89,7.26-3.46c.95,1.22,1.9,2.5,2.81,3.89a51.12,51.12,0,0,1,4.33,7.89c.07.16.12.33.19.49-.39-.46-2.73-2.81-2.91-3-2.31-1.86-7.87-4.09-10.65-2.26a3.93,3.93,0,0,0-.71,5.81c1.49,1.82,4.33,2.33,6.54,2.25,2.56-.09,7.58-2.63,7.77-2.72a68.08,68.08,0,0,1,2.84,8.52c.57,2.14,1.07,4.34,1.54,6.54-.52-.58-2.69-2.77-2.87-2.91-2.31-1.86-7.87-4.09-10.65-2.26a3.93,3.93,0,0,0-.71,5.81c1.49,1.82,4.33,2.33,6.54,2.25,2.5-.09,7.32-2.5,7.73-2.7.22,1,.43,2,.64,3,.68,3.28,1.35,6.58,2.1,9.81.26,1.12.56,2.21.86,3.31-.82-.85-2.33-2.37-2.47-2.49-2.31-1.85-7.88-4.08-10.65-2.26a3.93,3.93,0,0,0-.71,5.81c1.48,1.82,4.33,2.34,6.54,2.25s6.33-2,7.48-2.58c.5,1.82,1,3.62,1.66,5.36.28.75.52,1.53.83,2.23l.47,1.11-.64-.06s0,1,.05,2.73c-2.44-1.74-6-3.24-8.25-2.18a3.93,3.93,0,0,0-1.58,5.63,5.11,5.11,0,0,0,.51.71,15.35,15.35,0,0,0,3.16,7c.12.15,1.78,1.68,2.65,2.44-.84-.45-1.67-.9-2.53-1.38-1.25-.7-2.54-1.47-3.8-2.21l-1.94-1.23c-.66-.41-1.25-.87-1.89-1.31-.92-.67-1.84-1.4-2.75-2.13.78-1.22,3-4.86,3.33-7s.14-5.08-1.49-6.76a3.94,3.94,0,0,0-5.86,0c-2.13,2.55-.55,8.33,1,10.84,0,.08.44.58.91,1.16-.87-.74-1.75-1.47-2.61-2.25-2.44-2.2-4.86-4.53-7.29-6.84l-1.53-1.44c.66-1,3.11-5,3.45-7.17s.15-5.08-1.49-6.76a3.94,3.94,0,0,0-5.85,0c-2.13,2.55-.56,8.33,1,10.84.06.09.53.68,1.05,1.34-1.33-1.24-2.69-2.46-4.06-3.63a69.83,69.83,0,0,0-7.44-5.56c.24-.36,3.2-4.9,3.57-7.37.34-2.2.15-5.08-1.48-6.76a4,4,0,0,0-5.86,0c-2.13,2.55-.55,8.33,1,10.84.11.18,1.81,2.3,2.45,3l-.09-.06a51.62,51.62,0,0,0-8.16-4.06,69.84,69.84,0,0,0-7.74-2.56c-2.43-.68-4.7-1.15-6.71-1.55-1.08-.21-2.08-.38-3-.53l.06,0s-3.34-2.24-3.57-2.35c-2.66-1.32-8.57-2.31-10.89.07a3.94,3.94,0,0,0,.55,5.83c1.84,1.46,4.72,1.35,6.87.8s5.91-3.46,6.83-4.18c1,.17,2,.37,3.13.61,2,.44,4.24,1,6.65,1.69.64.19,1.32.43,2,.64-1.2-.13-2.84-.28-3-.28-3,0-8.67,1.9-9.63,5.08a3.93,3.93,0,0,0,3.17,4.92c2.3.45,4.82-1,6.47-2.46s3.72-5.92,4.15-6.89c1.46.5,3,1,4.48,1.7a51.25,51.25,0,0,1,8,4.18c.14.1.28.22.43.31-.58-.16-3.83-.84-4.06-.86-3-.28-8.83.93-10.13,4a3.94,3.94,0,0,0,2.61,5.24c2.24.7,4.9-.45,6.7-1.73,2.08-1.49,4.87-6.38,5-6.56a69.42,69.42,0,0,1,7.06,5.54c1.67,1.47,3.29,3,4.9,4.61-.76-.2-3.78-.83-4-.85-3-.27-8.82.94-10.13,4a3.94,3.94,0,0,0,2.61,5.24c2.24.7,4.9-.44,6.7-1.73,2-1.45,4.73-6.13,5-6.52l2.2,2.15c2.38,2.37,4.75,4.75,7.16,7,.84.79,1.69,1.54,2.54,2.29-1.14-.26-3.24-.7-3.43-.71-2.95-.28-8.82.93-10.13,4a3.94,3.94,0,0,0,2.62,5.24c2.24.69,4.89-.45,6.69-1.73s4.17-5.18,4.82-6.28c1.42,1.24,2.86,2.44,4.34,3.55.65.47,1.28,1,1.92,1.4l1.91,1.27c1.33.83,2.57,1.6,3.83,2.34l1.86,1.07c-1.12-.44-2.91-1.1-3.08-1.14-2.88-.72-8.86-.42-10.62,2.41a3.94,3.94,0,0,0,1.79,5.57c2.11,1,4.91.3,6.88-.7,2.18-1.1,5.46-5.16,5.86-5.66,1.53.87,3,1.7,4.43,2.45,3.77,2,7,3.63,9.6,4.82,8.29,7.17,20,8,20,8s.62-14-7.61-23.16A28.65,28.65,0,0,0,251.86,148.46Zm-14.8,13.62c.26-.58,2.24-5,2.38-7.52.46-.08.93-.18,1.38-.28a32.3,32.3,0,0,0,5.14,12.3c-1.51-.72-3.14-1.51-4.87-2.39C239.8,163.53,238.45,162.82,237.06,162.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,145.78s-14,.43-22.53,9.32S282,178,282,178s14-.43,22.53-9.32S313,145.78,313,145.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "276.47 154.79 290.19 142.45 289.61 141.79 276.46 153.61 276.39 137.44 276.46 137.49 288.07 120.51 287.35 120.01 276.38 136.04 276.22 97.12 275.34 97.13 275.45 123.54 266.71 115.98 266.14 116.64 275.46 124.71 275.54 143.59 262.29 131.88 261.71 132.53 275.54 144.77 275.62 161.97 265.66 154.16 265.12 154.85 275.62 163.09 275.67 174.16 276.55 174.16 276.46 154.78 276.47 154.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.82 159.55 262.95 159.45 261.84 169.22 255.95 162.64 255.96 162.64 254.46 150.81 253.59 150.92 254.93 161.5 240.28 145.12 239.62 145.71 249.56 156.82 243.27 156.9 243.28 157.78 250.34 157.69 257.31 165.48 247.47 165.49 247.47 166.37 258.1 166.36 264.43 173.44 257.49 173.86 257.55 174.74 265.18 174.28 269.4 179 270.06 178.41 262.63 170.1 263.82 159.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.99 163.03 308.67 160.66 308.5 159.8 298.05 161.92 313.29 146.09 312.65 145.48 302.31 156.22 301.77 149.95 300.89 150.03 301.5 157.06 294.25 164.59 293.51 154.78 292.63 154.85 293.43 165.44 286.84 172.29 285.91 165.4 285.04 165.52 286.06 173.1 281.67 177.66 282.31 178.27 290.04 170.24 300.65 170.65 300.69 169.77 290.86 169.39 296.99 163.02 296.99 163.03",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Grade--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.58,298.69c.79,3.93,10.23,5.51,10.23,5.51l7-4c2.93,24.6,5.53,44.68,6.4,46.43,2.36,4.72,19.67-1.57,21.24-9.44.64-3.18-2.46-24.63-6.37-49.05l24.46-13.88s1.07-3.51-6.54-2.15c-2.66.48-10.42,3.37-19.36,7.11-5.5-33.7-11.86-69.46-11.86-69.46s83.38,90.46,87.32,90.46,9.44-.78,7.08-7.86-94.4-95.18-94.4-95.18-15.73-.79-18.87,6.29c0,0,4.91,45.52,9.55,85.24C169.25,293.2,162.28,297.19,162.58,298.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.56,275.5a82.53,82.53,0,0,0-1.21-12.14,83.56,83.56,0,0,0-7.59-23.09,84.3,84.3,0,0,0-6.09-10.41,92.57,92.57,0,0,0-7.3-9.46,97.41,97.41,0,0,0-8.29-8.46A125,125,0,0,0,299.36,198c-26.46-16.07-57-23.44-87.24-23a143.07,143.07,0,0,0-22.53,2.42,107.24,107.24,0,0,0-21.71,6.42,91.12,91.12,0,0,0-19.53,11.21,99.25,99.25,0,0,0-16.2,15.24l0,0a.5.5,0,0,0,0,.68.5.5,0,0,0,.71,0,97.24,97.24,0,0,1,16.75-14,89,89,0,0,1,19.42-9.93c13.73-5,28.44-6.89,43-6.75a164.14,164.14,0,0,1,43.2,6.46,152,152,0,0,1,39.83,17.82c12.23,7.89,23.26,17.87,31.26,30a75.5,75.5,0,0,1,5.36,9.47,74.59,74.59,0,0,1,6.49,20.67,74.2,74.2,0,0,1,.93,10.83,85.56,85.56,0,0,1-.58,10.85c-.27,1.79-.52,3.58-.87,5.36l-.61,2.64-.3,1.32-.39,1.3a72.59,72.59,0,0,1-9.09,19.63c-8,12.1-19.37,21.79-31.95,29a133.72,133.72,0,0,1-40.83,14.94,163,163,0,0,1-43.54,2.5c-1.83-.08-3.64-.33-5.45-.49-.91-.1-1.82-.18-2.72-.29l-2.7-.41c-1.8-.3-3.61-.5-5.39-.88L189.38,360a27,27,0,0,1-2.65-.67l-2.63-.73c-1.76-.49-3.52-.95-5.23-1.58l-5.17-1.77-5.07-2.05c-.84-.35-1.69-.68-2.52-1.05L163.64,351c-1.64-.8-3.31-1.53-4.92-2.38-3.19-1.77-6.44-3.43-9.48-5.45l-2.31-1.45-1.16-.73-1.11-.79L140.21,337c-1.49-1.06-2.86-2.27-4.29-3.4l-2.12-1.72c-.72-.56-1.36-1.22-2-1.82l-4-3.7L124,322.39c-.62-.67-1.27-1.3-1.86-2l-1.75-2.1-1.75-2.1c-.57-.71-1.19-1.38-1.69-2.14l-3.18-4.44-.8-1.11-.71-1.17L110.8,305a108.2,108.2,0,0,1-5.17-9.61,78.9,78.9,0,0,1-6.31-20.8,72.22,72.22,0,0,1,.11-21.72A81.08,81.08,0,0,1,105.7,232a101.27,101.27,0,0,1,11.19-18.74,132.14,132.14,0,0,1,31.81-29.83.49.49,0,0,0,.15-.67.5.5,0,0,0-.68-.17h0A143.65,143.65,0,0,0,130,195.38a122.92,122.92,0,0,0-15.81,15.88,99.61,99.61,0,0,0-12.45,19,85.7,85.7,0,0,0-7.51,21.83,77.14,77.14,0,0,0-.84,23.41,85.43,85.43,0,0,0,6.14,22.72,109.63,109.63,0,0,0,11.55,20.29c.53.82,1.17,1.55,1.76,2.32l1.82,2.29,1.81,2.28c.62.75,1.3,1.45,1.94,2.17l3.94,4.3,4.19,4c.71.66,1.38,1.37,2.12,2l2.22,1.88c1.49,1.23,2.92,2.55,4.47,3.71L140,347l1.17.87,1.2.8,2.43,1.6c3.18,2.23,6.62,4,10,6,1.7.92,3.46,1.73,5.19,2.61l2.61,1.28c.88.41,1.78.77,2.67,1.15l5.36,2.26,5.49,2c1.82.7,3.69,1.22,5.56,1.77l2.8.82c.93.28,1.87.55,2.83.75l5.7,1.31c1.91.44,3.86.69,5.79,1l2.9.48c1,.14,1.91.23,2.86.35,1.91.2,3.82.49,5.74.61a157.43,157.43,0,0,0,23.09.42,170.44,170.44,0,0,0,23-2.75,143,143,0,0,0,43.93-15.83c13.65-7.89,26.12-18.62,35.12-32.3a82.28,82.28,0,0,0,10.19-22.35l.43-1.48.35-1.51.67-3c.39-2,.67-4.08,1-6.11A86,86,0,0,0,348.56,275.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.91,209.76a3.49,3.49,0,0,0,3.14,2,3.38,3.38,0,0,0,1.54-.36l14-6.87,9.17,7.8a3.5,3.5,0,1,0,4.53-5.33l-6.86-5.84,7.73-3.81A3.5,3.5,0,1,0,241,191l-10.45,5.15-7.34-6.25a3.5,3.5,0,0,0-4.54,5.33l5,4.29-11.24,5.53A3.5,3.5,0,0,0,210.91,209.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429,419l-65.79-28.74c-8-6.81-17.47-14.67-19-15.06-2.78-.7-1.39-4.17,3.48-12.52s-29.43-24.34-38.2-23.49c-7,.69-15.34-.72-18.35-1.3,2.51-7.45,5.1-14.84,5.1-14.84l-34.09-14.92L235,266.71l-8.48,2.7s11.88,27.12,25.81,58.17c-5.14-1.64-15.59-3.87-16.63,4.49-1.39,11.12,6.95,19.47,15.29,19.47,4.6,0,9-.21,12-.4,15.21,33.47,30,64.85,32.52,66.45,5.57,3.48,25,8.34,25.73,3.48s-19.47-40.33-19.47-40.33S408.85,423.15,420,423.15,429,419,429,419ZM327.5,359.18s-3.1,8.91-2.65,14.3l-18.26-8Zm-49.37-36.85-2.44,6.52-5.58-8.52Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.4,203.55s2.17-4.62.81-8.16-26.38-9.25-26.38-9.25-5.72,0-5.45,3.26,20.95,15.78,22.58,16.87S386.85,209.81,387.4,203.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.9,200.83a11.23,11.23,0,0,1,7.34-5.44c5.17-1.09,12,2.45,12.79,8.16s-3.54,8.43-6.26,8.43-5.17-3.81-5.17-3.81S368.9,204.91,368.9,200.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.2,227.68a18.16,18.16,0,0,0,11.68,10.43c9.18,2.92,26.28-1.25,36.29,0l7.5,7.93L406,253.54a244.31,244.31,0,0,0-26.28-7.09c-13.86-2.85-22.52-15.85-22.52-15.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.07 265.55 226.53 269.41 229.18 271.33 233.52 269.89 232.07 265.55",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.93,172.73s-2.38-.87-4.54-1.95.21,3.89,1.08,4.11,3,.65,3,.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.86,250.56l-10.74,14.27a3.3,3.3,0,0,0-.32,3.47h0a3.31,3.31,0,0,0,3.53,1.78l15.58-2.71,168.53-96.89a16.67,16.67,0,0,0,5.76-23.22h0A16.66,16.66,0,0,0,401,142.11Z",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,142.11l-44.92,31c.42,7.78,3.76,18.08,17.37,22.63l45-25.29A16.66,16.66,0,1,0,401,142.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.8,268.3h0a3.31,3.31,0,0,0,3.53,1.78l15.58-2.71c-12.6-4.9-8-16.81-8-16.81l-10.74,14.27A3.3,3.3,0,0,0,230.8,268.3Z",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.11,177.7s-2.42,0-2.42,1.1-.63,5,.77,4.89,1.27-2.57,1.39-3.43S344.11,177.7,344.11,177.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.76,173.71s-2.17-.66-2.66.67-1,7.64.49,7.48S346.42,176,346.76,173.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.08,174.05s-2.49-2.16-3.32-.34-1,7,0,7,2.49-2.16,2.82-3.32A22.75,22.75,0,0,0,350.08,174.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,175s-3.16-2.66-3.66-2.16-2.49,5.62-1,6.65,3.39-3.56,3.39-3.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.91,199.66s.35,5.34,1.77,6.58a16.49,16.49,0,0,1,2.32,2.49,37.71,37.71,0,0,1,.35,4.09c0,1.6,1.07,1.43,2,1.43s2.49,3,3.38,4.44a9.26,9.26,0,0,0,3.77,3c1.6.88,4.26-2.49,4.26-2.49l3.52,5.85,12.63-8.18-6.22-12.09a29,29,0,0,0-3.74-11.91c-3.55-6.4-8.36-10-16.36-7.65S313.91,199.66,313.91,199.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334,
    y1: 221.54,
    x2: 328.59,
    y2: 216.1,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.66,205.9a3.21,3.21,0,0,1-3.53,0,7.12,7.12,0,0,1-3.13-6.27c0-2.75-3.53-1.57-3.53-1.57s-3.93,4.31-6.67,2.74-4.32-4.7,3.53-14.51,15.3-9.41,21.57-5.49,8.75,24,8.75,24-.12,3.83-5.22,5S324.66,209.82,324.66,205.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.69,209.27s-1.78-6.76,1.06-5.87,4.45,6.93,4.27,7.64-1.6,1.07-2.31.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.24,211.72a73.84,73.84,0,0,0-9.48,6.32c-3,2.67-5.69,10.67-5.69,10.67s18.32-12.45,21.52-14.23,3.91-2.66,3.91-2.66S347.8,210.83,344.24,211.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.11,259.52s-5.18-2.4-11.16-5.59-12.36-6.77-12.36-6.77a21.26,21.26,0,0,0-5.18,0,64.08,64.08,0,0,1-9.17,1.59c-2,0-3.19,2-2,2.79s7.58,0,7.58,0l-10,4.79s-1.19,2.39,1.6,2.39,4-.4,7.17,0,9.57-3.59,9.57-3.59,16.88,19.45,20.8,19.69S307.89,265.9,299.11,259.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.43,255.78s-8.71,2.45-10.34,6.26-1.36,9.52,1.9,12.78,4.63,4.08,8.16,2.72,4.36-3.53,4.63-5.71S311,262.31,304.43,255.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.91,408.88a35,35,0,0,0-1.9,3.54c-.27.82-6.26,1.63-5.44,4.35s7.07,4.9,10.07,5.17,9-3.81,10.06-4.9c.64-.64,1.6-4.86,1.09-8.16a8.49,8.49,0,0,0-2.18-4.08S427.44,396.91,420.91,408.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.79,408.88a8,8,0,0,0-1.85-3.71,8.27,8.27,0,0,0-6,2.63c-2.72,3.26-1.36,10.6-4.63,11.69-2.43.81-6.68-2.16-8.68-3.72a1.54,1.54,0,0,0,0,1c.82,2.72,7.07,4.9,10.07,5.17s9-3.81,10.06-4.9C434.34,416.4,435.3,412.18,434.79,408.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.72,410.79c-1.09,4.89.27,8.16-4.08,11.15,3,.27,9-3.81,10.06-4.9.64-.64,1.6-4.86,1.09-8.16a6.36,6.36,0,0,0-.67-1.94l-.42,0S428.8,405.89,427.72,410.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.25,372.7c-4.08-8.16-20.59-30.14-20.59-30.14s-7.61-47.59-7.89-50.87c-.52-6.28-4.55-15.76-4.55-15.76s-13.13-2.74-38.16,11.95l.27,8.16,17.45,21.52c.84-.69,1.33-1.11,1.33-1.11s11.15,28,13.6,33.46,14.54,24.79,20.54,28.79c3.34,2.23,27.66,30.18,27.66,30.18s4.63-4.08,7.62-4.08h4.08S415.33,380.86,411.25,372.7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.76,397.39c3.32,4.19,5.51,7.32,5.51,7.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.08,319.35s4.31,11.21,9.92,24.14,12.5,28.46,22.85,36.22c4.37,3.27,9,8.24,13,12.88",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "377.88 308.01 359.11 316.44 379.02 315.47",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.61,198.93c-4.62.54-16.59,8.7-17.41,9.52s-4.08,2.72-5.44,3.81c0,0-28,17.41-30.47,19s-7.34,4.89-7.07,6-14.42,25-14.42,25-4.35,5.71-.27,10.88,7.89,1.63,9.79.55,16.87-15.24,16.87-15.24L340,291.45s19.12-12.82,39.52-12l-13.6-53.32s18.77-14.15,19.31-19S379.24,198.38,374.61,198.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-69)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.61,198.93c-1.85.21-4.88,1.65-7.9,3.36a3.57,3.57,0,0,1,3.64,1.52c2.25,2.89-2.57,12.19-2.57,12.19s-2-12.86-1.92-9-1,15.72-1,15.72-6.42-7.7-6.1-5.77,4.49,19.89,7.06,26.63-1.93,25.67-4.49,31.13-1-23.1-3.85-16.05S345,285.32,342.75,287.25s.72-26.17,1.52-29.83c-1,3.06-7.61,22.44-7.61,22.44l-9-23.1s-15.4-12.52-13.8-10.27,5.46,9.31,5.46,9.31-9.31-1.93-7.7-1.29,8.66,4.17,8.66,4.17S305.85,269,301.68,270.24a16.62,16.62,0,0,1-3.44.63,8.18,8.18,0,0,0,1.29,2.32c4.08,5.17,7.89,1.63,9.79.55s16.87-15.24,16.87-15.24L340,291.45s19.12-12.82,39.52-12l-13.6-53.32s18.77-14.15,19.31-19S379.24,198.38,374.61,198.93Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.61,198.93c-1.85.21-4.88,1.65-7.9,3.36a3.57,3.57,0,0,1,3.64,1.52c2.25,2.89-2.57,12.19-2.57,12.19s-2-12.86-1.92-9-1,15.72-1,15.72-6.42-7.7-6.1-5.77,4.49,19.89,7.06,26.63-1.93,25.67-4.49,31.13-1-23.1-3.85-16.05S345,285.32,342.75,287.25s.72-26.17,1.52-29.83c-1,3.06-7.61,22.44-7.61,22.44l-9-23.1s-15.4-12.52-13.8-10.27,5.46,9.31,5.46,9.31-9.31-1.93-7.7-1.29,8.66,4.17,8.66,4.17S305.85,269,301.68,270.24a16.62,16.62,0,0,1-3.44.63,8.18,8.18,0,0,0,1.29,2.32c4.08,5.17,7.89,1.63,9.79.55s16.87-15.24,16.87-15.24L340,291.45s19.12-12.82,39.52-12l-13.6-53.32s18.77-14.15,19.31-19S379.24,198.38,374.61,198.93Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.61,198.93c-4.62.54-16.59,8.7-17.41,9.52s-4.08,2.72-5.44,3.81c0,0-28,17.41-30.47,19s-7.34,4.89-7.07,6-14.42,25-14.42,25-4.35,5.71-.27,10.88,7.89,1.63,9.79.55,16.87-15.24,16.87-15.24L340,291.45s19.12-12.82,39.52-12l-13.6-53.32s18.77-14.15,19.31-19S379.24,198.38,374.61,198.93Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,291.45A71.62,71.62,0,0,1,341.14,269",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.41,274.78s0-4.6,5.17-19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "315.58 246.53 326.19 258.5 315.31 250.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "365.91 210.9 365.91 226.13 369.44 206.54",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.36,257.08a1.73,1.73,0,0,0-.09.34C344.39,257.05,344.43,256.91,344.36,257.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.58,191.87a3.5,3.5,0,0,1-2-6.39l40.33-27.66a3.5,3.5,0,1,1,4,5.77l-40.33,27.67A3.5,3.5,0,0,1,350.58,191.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.05,
    y1: 186.03,
    x2: 392.41,
    y2: 164.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.51,
    y1: 179.45,
    x2: 388.87,
    y2: 157.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.33,296s-30.21,35.13-30.87,43.13,5.33,16,12.66,18,78.79,3.59,78.79,3.59l-.67-13.33-63.45-9.59,21-20.28",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 387.55,
    y1: 353.29,
    x2: 392.38,
    y2: 353.84,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.61,336.57l-1.38,1.75s8.62-.43,6.9,1.29a9.61,9.61,0,0,0-2.16,4.74l5.17-1.29s-3,6-.86,5.61a23.29,23.29,0,0,0,4.74-1.73l50,5.71",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.41,290s-8.2,5.61-4.31,6.47,8.62-.43,7.32,1.29a75.79,75.79,0,0,1-6,6l-19.25,24.44",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1,296.5s4.74-6.9,15.52-7.33",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,347.27s7.51-1.71,8.88.68,2.05,8.19,2.05,10.92,2,7.17,1.7,11.27-6.48,8.53-8.53,8.53-2-12.29-4.1-17.07S396.48,350,398.86,347.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.6,378.56c2.46-.68,7.58-4.69,7.89-8.42.35-4.1-1.7-8.54-1.7-11.27s-.69-8.53-2.05-10.92c-.61-1.07-2.45-1.32-4.3-1.27a4.6,4.6,0,0,0-1.26,3.89c.48,3.91,4.39,19.79,2.93,24.19A35.23,35.23,0,0,1,403.6,378.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.74,348a2.46,2.46,0,0,0-1.56-1,9.24,9.24,0,0,0-1.76,6.11c.43,6.51,1.74,11.73,2.17,17.37a13.45,13.45,0,0,1-1.11,7.27c2.56-1.53,5.77-4.62,6-7.55.35-4.1-1.7-8.54-1.7-11.27S409.1,350.34,407.74,348Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.8f76e64b6aa9b3a33d7f89f4d914fa65.svg";
export { ForwardRef as ReactComponent };